import { HomeState } from "@/components/PageHome/redux/types";

const homeInitialState: HomeState = {
  currentFlow: undefined,
  flowData: undefined,
  homeData: undefined,
  loading: false,
  error: null,
};

export default homeInitialState;
